// extracted by mini-css-extract-plugin
module.exports = {"visibleTextNotTruncated":"_1782f5","ellipsis":"_760eb8","link":"_93f14c"};